export default [
    {
        path: 'classPurchase',
        name: 'GainSuccessClassPurchase',
        component: () =>
            import(/* webpackChunkName: "login" */ '../views/gainSuccess/classPurchase.vue'),
    }
]